import "@userjot/core";

/**
 * A higher-order function that ensures a given function is only called on the client-side.
 * Throws an error if called on the server.
 * @param fn The function to be wrapped.
 * @returns The wrapped function.
 */
const ensureClientSide = <T extends (...args: any[]) => any>(fn: T) => {
  if (typeof window === "undefined") {
    console.warn("UserJot client functions cannot be used on the server.");
    return (() => {}) as T;
  }
  if (typeof window.uj === "undefined") {
    console.warn("UserJot library is not available on the window object.");
    return (() => {}) as T;
  }
  return fn;
};

const identify: (typeof window)["uj"]["identify"] = ensureClientSide(
  (options) => {
    window.uj.identify(options);
  }
);

/**
 * A React hook that provides access to UserJot client functions.
 * @returns An object containing UserJot client functions.
 */
export const useUserJot = () => {
  return {
    identify,
  };
};
